import React from 'react';

interface LoadingSkeletonProps {
  title?: boolean;
  input?: boolean;
  items?: number;
  itemHeight?: string;
}

const LoadingSkeleton: React.FC<LoadingSkeletonProps> = ({
  title = true,
  input = false,
  items = 3,
  itemHeight = 'h-20',
}) => {
  return (
    <div className="p-4">
      <div className="animate-pulse">
        {title && (
          <div className="h-8 bg-gray-200 rounded w-1/3 mb-4"></div>
        )}
        
        {input && (
          <div className="h-12 bg-gray-200 rounded mb-4"></div>
        )}
        
        <div className="space-y-4">
          {Array.from({ length: items }).map((_, i) => (
            <div key={i} className={`bg-gray-200 ${itemHeight} rounded`}></div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default LoadingSkeleton; 